export enum RestApiId {
  IP_BLACKLIST = 'IP_BLACKLIST',
}
